'use strict'; /* eslint-disable no-console, no-unused-vars */

import Cleave from 'cleave.js';
require('cleave.js/dist/addons/cleave-phone.us');

const formatInputs = (function(){
	let creditCard;
	let phone;
	let numbers;
	let expiryDate

	function init() {
		creditCard = document.querySelector('.js-input-credit-card');
		phone = document.querySelector('.js-input-phone');
		numbers = document.querySelectorAll('.js-input-number');
		expiryDate = document.querySelector('.js-input-expiry-date');

		const region = (window.globals.region == 'UK') ?  'UK' : 'US';

		if( creditCard ) {
			new Cleave('.js-input-credit-card', {
				creditCard: true,
				delimiter: ' - ',
				onCreditCardTypeChanged: function (type) {
					// update UI ...
					// console.log(type);
				},
			});
		}

		if( phone ) {
			new Cleave('.js-input-phone', {
				phone: true,
				phoneRegionCode: 'US',
			});
		}

		if( numbers ) {
			[].forEach.call(numbers, (number) => {
				new Cleave(number, {
					numeral: true,
					numeralPositiveOnly: true,
					numeralThousandsGroupStyle: 'thousand',
				});
			})
		}


		if (expiryDate) {
			new Cleave(expiryDate, {
				date: true,
				datePattern: ['m', 'y'],
			});
		}
	}

	window.addEventListener('DOMContentLoaded', init);

})();

export default formatInputs;


// WEBPACK FOOTER //
// ./resources/assets/js/input-formatting.js